<template>
  <div class="container">
    <arrorImg bg="white"></arrorImg>
    <!-- 导航选项卡-->
    <div class="nav_item">
      <div>
        <span
          class="man_title"
          :key="index"
          v-for="(item, index) in items"
          @click="changeFrency(index)"
          :class="currentIndex == index ? 'active' : ''"
          >{{ item }}</span
        >
      </div>
    </div>
     <navBar></navBar>
    <div class="sort-content">
      <div class="sort-title">
        <span
          :class="categoryId == 0 ? 'active' : ''"
          @click="chooseSort(0, '全部')"
          style="width: 4.25rem"
          >全部</span
        >
        <div>
          <span
            @click="chooseSort(item.id, item.categoryName)"
            v-for="(item, index) in navList"
            :key="index"
            :class="categoryId == item.id ? 'active' : ''"
            >{{ item.categoryName }}</span
          >
        </div>
      </div>
      <div class="sort-status">
        <span
          :class="bookFinish == -1 ? 'active' : ''"
          @click="chooseFinish(-1)"
          style="width:4.25rem"
          >全部</span
        >
        <div>
          <span
            :class="bookFinish == 1 ? 'active' : ''"
            @click="chooseFinish(1)"
            >连载</span
          >
          <span
            :class="bookFinish == 0 ? 'active' : ''"
            @click="chooseFinish(0)"
            >完结</span
          >
        </div>
      </div>
    </div>
    <!-- 左侧排行榜 -->
    <div class="content_class" v-if="!isEmpaty">
      <div class="sort_class">
        <ul
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <li
            v-for="(itemChild, index) in sortList"
            :key="index"
            @click="routeDetail(itemChild)"
          >
            <uniListItem :itemChild="itemChild"></uniListItem>
          </li>
        </ul>
        <div class="load-more">
         <span>{{ !isLoading ?'加载中':loadingText }}</span>
        </div>
      </div>
    </div>
    <div class="no-log" v-else>
      <img src="../../../static/no-log.png" alt="" />
      <span>没有内容哦，去其他地方看看吧~</span>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import uniListItem from "../components/list-itemone.vue";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name:'bookClass',
  components: {
    uniListItem,
    navBar,
    arrorImg
  },
  data() {
    return {
      loading: false,
      isEntranceData: "",
      isEmpaty: false,
      items: [],
      navList: [], //左边导航数据
      sortList: [], //排行榜数据
      pageNo: 1,
      pageSize: 10,
      id: 0,
      CountPage: 1,
      loadingText: "加载中...",
      isLoading:false,
      currentIndex: 0,
      categoryId: 0,
      bookFinish: -1,
      sortName: "全部",
      finishName: "全部",
      frequencyName: "男",
      messageType: "",
      clickMessId: 0,
      channelRecordId: 0,
      promotionCode: "",
      pageType:'',
      frequencyDefualtType:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    // if (!this.$route.meta.isBack) {
    //   if (this.$base.getStorage("currentIndex")) {
    //     this.currentIndex =  this.$base.getStorage("currentIndex");
    //   } else {
    //     this.currentIndex = this.$base.getStorage("frequency") ? 1 : 0;
    //   }
    // } else {
    //   if (this.$base.getStorage("currentBack")) {
    //     this.currentIndex = this.$base.getStorage("currentBack");
    //   } else {
    //     if (this.$base.getStorage("currentIndex")) {
    //       this.currentIndex = current;
    //     } else {
    //       this.currentIndex = this.$base.getStorage("frequency") ? 1 : 0;
    //     }
    //   }
    // }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
     var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.pageNo=1;
      this.getOutReaderSwitckIsOpen();
    } else {
        this.pageNo=1;
        this.getOutReaderSwitckIsOpen();
    }
    this.$commonApi.share();
  },
     beforeRouteLeave(to, from, next) {
     if(from.name=='bookClass'&&to.name == "bookDetail"){
      from.meta.isBack = true;
      from.meta.keepAlive = true;
     }else{
        from.meta.isBack = false;
      from.meta.keepAlive = false;
     }
    next();
  },
  methods: {
    getOutReaderSwitckIsOpen() {
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
    if (res.status == 1) {
      this.frequencyDefualtType=res.data.frequencyDefualtType
    this.getfrequencyDefualtType();
    this.getCategoryByFrequency();
    }
  });
  },
  getfrequencyDefualtType(){
		if (this.$base.getStorage("frequency") === "") {
      this.currentIndex=0;
		}
		  if(this.frequencyDefualtType==1){//男女
        this.items=["男频", "女频"];
        this.currentIndex=this.$base.getStorage("frequency")==1? parseInt(this.$base.getStorage("frequency")): 0;
        this.frequencyName=this.currentIndex == 0 ? "男" : "女";
		  }else if(this.frequencyDefualtType==2){//女男
        this.items=["女频", "男频"];
        this.currentIndex=this.$base.getStorage("frequency")==1? 0:1
        this.frequencyName=this.currentIndex == 0 ? "女" : "男";
		  }else if(this.frequencyDefualtType==3){
        this.frequencyName= "男";
      }else if(this.frequencyDefualtType==4){
        this.frequencyName= "女";
      }
	  },
    loadMore() {
      this.loading = true;
      if (this.pageNo < this.CountPage) {
        this.pageNo += 1;
        this.getBookByCategory();
      } else {
        this.loadingText = "没有更多了";
        this.loading = false;
      }
    },

    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCity") {
        prevPage = "书城";
      } else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      }
      var params = {
        pageName: "分类",
        pageRemark:'上级页面：'+prevPage+';'+this.frequencyName + "-" + this.sortName + "-" + this.finishName,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getCategoryByFrequency() {
      var frequency=0;
      if(this.frequencyDefualtType==1){
        frequency = this.currentIndex 
      }else if(this.frequencyDefualtType==2){
        frequency =  this.currentIndex ==0?1:0;
      }else if(this.frequencyDefualtType==3){
        frequency = 0;
      }else if(this.frequencyDefualtType==4){
        frequency = 1;
      }
      var params = {
        frequency:frequency,
      };
      this.$api.getCategoryByFrequency(params).then((res) => {
        if (res.status == 1) {
          this.navList = res.data;
          this.getBookByCategory();
          this.insertPageAccessData();
        }
      });
    },
    getBookByCategory() {
      var frequency=0;
      if(this.frequencyDefualtType==1){
        frequency = this.currentIndex 
      }else if(this.frequencyDefualtType==2){
        frequency =  this.currentIndex ==0?1:0;
      }else if(this.frequencyDefualtType==3){
        frequency = 0;
      }else if(this.frequencyDefualtType==4){
        frequency = 1;
      }
      var params = {
        frequency: frequency,
        categoryId: this.categoryId,
        finishStatus: this.bookFinish,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.isLoading=false;
      this.$api.getBookByCategory(params).then((res) => {
        if (res.status == 1) {
          this.CountPage = res.pages;
          res.data.forEach((item) => {
            var num = (item.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              item.studyingVolume = 999.99;
            } else {
              item.studyingVolume = num;
            }
          });
          if (this.CountPage > 1) {
            this.loadingText = "加载中";
          } else {
            this.loadingText = "没有更多了";
          }
          if (this.pageNo == 1) {
            this.$nextTick(()=>{
                window.scrollTo(0, 0);
            })
            this.sortList = res.data;
          } else {
            this.sortList = this.sortList.concat(res.data);
          }
          if (this.sortList.length == 0) {
            this.isEmpaty = true;
          } else {
            this.isEmpaty = false;
          }
         this.isLoading=true;
        }
      });
    },
    changeFrency(index) {
      this.currentIndex = index;
    if(this.frequencyDefualtType==1){//男女
      this.frequencyName=index == 0 ? "男" : "女"
		  }else if(this.frequencyDefualtType==2){//女男
      this.frequencyName=index == 0 ? "女" : "男"
		  }
      this.bookFinish = -1;
      this.categoryId = 0;
      this.pageNo = 1;
      this.finishName = "全部";
      this.sortName = "全部";
      this.$base.setStorage("currentBack", this.currentIndex);
      window.scrollTo(0, 0);
      this.getCategoryByFrequency();
      this.insertPageAccessData();
    },
    chooseSort(id, name) {
      this.categoryId = id;
      this.pageNo = 1;
      this.sortName = name;
      window.scrollTo(0, 0);
      this.insertPageAccessData();
      this.getBookByCategory();
    },
    chooseFinish(index) {
      this.bookFinish = index;
      this.pageNo = 1;
      if (this.bookFinish == -1) {
        this.finishName = "全部";
      } else if (this.bookFinish == 1) {
        this.finishName = "连载";
      } else if (this.bookFinish == 0) {
        this.finishName = "完结";
      }
      this.insertPageAccessData();
      this.getBookByCategory();
    },
    routeDetail(item) {
      this.$router.push({
        path: "/pages/bookDetail/index",
        query: {
          pageType: "bookClass",
          bookId: item.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.container {
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.nav_item {
  padding: 0px 16px;
  position: fixed;
  left: 50%;
  top: 0px;
  box-sizing: border-box;
  z-index: 999;
  display: flex;
  height: 40px;
  transform: translateX(-50%);
  align-items: center;
  background-color: #ffffff;
}

.nav_item img {
  width: 9px;
  height: 16px;
}

.nav_item > div {
  width: 100%;
  text-align: center;
}

.nav_item span {
  color: #000000;
  border-bottom: 3px solid #ffffff;
  padding-bottom: 8px;
}

.nv_title {
  margin-left: 36px;
}

.man_title {
  margin-left: 18px;
  font-size: 14px;
}

.nav_item span.active {
  font-weight: bold;
  border-bottom: 3px solid #de3b34;
}

.load-more {
  text-align: center;
   font-size: 12px;
color: #AAAAAA;
 padding: 16px 0px;
}

.content_class {
  padding: 0px 16px;
}

.sort-content {
  padding: 20px 16px 0px 0px;
  width: 100%;
  box-sizing: border-box;
  /* margin-top: 50px; */
  padding-top:50px;
}
.sort-title,
.sort-status {
  margin-bottom: 4px;
  display: flex;
}

.sort-title div,
.sort-status div {
  overflow: hidden;
  width: 80%;
  /* width: 258px; */
}

.sort-title span,
.sort-status span {
  font-size: 14px;
  color: #666666;
  padding-bottom: 12px;
  width: 25%;
  display: block;
  float: left;
  text-align: center;
}

.sort-title .active,
.sort-status .active {
  color: #de3b34;
}

.no-log {
  width: 100%;
  margin-top: 100px;
}

.no-log span {
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
  display: block;
  text-align: center;
}

.no-log img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookClass/index.vue